import React from "react";
import { motion } from "framer-motion";
import Multilingualism from "../../../images/Multilingualism.png";

const MultilingualismSection = ({ className = "" }) => {
  return (
    <section className={`flex flex-col items-center py-8 ${className}`}>
      <motion.img
        src={Multilingualism}
        alt="Multilingualism"
        className="w-[80%]"
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{
          opacity: 1,
          scale: 1,
          y: [0, -5, 0, 5, 0], // Wave effect
          boxShadow: [
            "0px 0px 0px rgba(255, 255, 255, 0.2)",
            "0px 0px 10px rgba(255, 255, 255, 0.5)",
            "0px 0px 0px rgba(255, 255, 255, 0.2)",
          ],
        }}
        transition={{
          duration: 2,
          ease: "easeInOut",
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
    </section>
  );
};

export default MultilingualismSection;
